export default __webpack_public_path__ + "static/media/wordpress.9674ebe0.svg";